export default __webpack_public_path__ + "static/media/img2-mobile.cceda181.png";